import { Component } from '@angular/core';
import { CfetBaseComponent } from '../cfet-core';

@Component({
    selector: 'app-cfet-footer',
    templateUrl: './cfet-footer.component.html',
    styleUrls: ['./cfet-footer.component.scss'],
    standalone: false
})
export class CfetFooterComponent extends CfetBaseComponent  {

  constructor() { super(); }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method

}
